<template>
    <li class="sidebar-item">
    <span class="sidebar-link">
        <div style="display:flex;justify-content:space-between">
            <div style="display:flex;align-items:center">
                <!-- Affichage de la couleur -->
                <div :style="{width: '12px', height:' 12px' , borderRadius: '0%', marginRight: '10px', backgroundColor: deviceItem.color,boxShadow:'1px 1px 1.8px #383838'}"></div>
                <span style="margin-right: 8px;">{{ deviceItem.name }}</span>

            </div>
            <div style="display:flex;align-items:center">
                <!-- Affichage de l'état en ligne ou hors ligne -->
                <i class="fas fa-circle text-success fa-fw" v-if="deviceItem.online" style="font-size: 10px;"></i>
                <i class="fas fa-circle text-danger fa-fw" v-else style="font-size: 10px;"></i>
                <!-- Affichage de l'état de la batterie -->
                <i class="align-middle me-2 fas fa-fw fa-battery-empty" style="color: red;" v-if="deviceItem.lowbattery == 0"></i>
                <i class="align-middle me-2 fas fa-fw fa-battery-full" v-else></i>
                <!-- Affichage du dernier événement -->
                <span class="" v-if="deviceItem.last_event_time != null">{{ getTimeSinceLastConnection(deviceItem) }}</span>
                <span class="" v-else>N/A</span>
            </div>
        </div>
    </span>
</li>

</template>
<script>
// import { mapActions} from 'vuex';

export default {
    name: "DeviceItem",
    computed: {
       

    },

    props:{
        deviceItem:{
            type : Object,
            required:true,
        }
    },
    methods: {
        getTimeSinceLastConnection(device) {
            // Essayer latest_event d'abord, puis eventsdata[0]
            const latestEvent = device.latest_event || (device.eventsdata && device.eventsdata[0]);

            if (!latestEvent) {
                return '⚪ Jamais';
            }

            // Essayer différents champs de date
            let dateStr = latestEvent.received_date ||
                         latestEvent.created_at ||
                         latestEvent.updated_at;

            if (!dateStr) {
                return '⚪ Jamais';
            }

            const lastConnection = new Date(dateStr);

            // Si la date est invalide
            if (isNaN(lastConnection.getTime())) {
                return '⚪ Inconnue';
            }

            // Formater la date : JJ/MM/AAAA HH:MM:SS
            const day = String(lastConnection.getDate()).padStart(2, '0');
            const month = String(lastConnection.getMonth() + 1).padStart(2, '0');
            const year = lastConnection.getFullYear();
            const hours = String(lastConnection.getHours()).padStart(2, '0');
            const minutes = String(lastConnection.getMinutes()).padStart(2, '0');
            const seconds = String(lastConnection.getSeconds()).padStart(2, '0');

            return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
        }
    }
}
</script>